export default __webpack_public_path__ + "static/media/closemodalicon.daaa592c.jpeg";